// eslint-disable-next-line no-restricted-syntax
enum PriceUnitEnum {
    Box = 'Box',
    CubicMetre = 'CubicMetre',
    LinearMetre = 'LinearMetre',
    SquareMetre = 'SquareMetre',
    Unit = 'Unit',
}

export default PriceUnitEnum;
